import React from "react";
import { Facebook, Twitter, Linkedin, Instagram, MapPin, Mail } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="10275" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 bg-white/10 animate-pulse rounded-none" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <div className="flex flex-col gap-3">
        <Link to="/HomePage" className="text-[#F6FAFE]/60 hover:text-[#FF6600] transition-colors text-xs">Home</Link>
        <Link to="/ServicesAndSEOPage" className="text-[#F6FAFE]/60 hover:text-[#FF6600] transition-colors text-xs">Services</Link>
        <Link to="/ContactPage" className="text-[#F6FAFE]/60 hover:text-[#FF6600] transition-colors text-xs">Contact</Link>
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-[#F6FAFE]/60 hover:text-[#FF6600] transition-colors text-xs">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function SiteReadyFooter() {
  const currentYear = new Date().getFullYear();
  const services = ['SEO & Local SEO', 'Digital Marketing Strategy', 'Paid Search Advertising', 'Social Media Marketing', 'Branding & Positioning'];
  return <footer id="footer" className="dark bg-[#000000] text-[#F6FAFE] border-t border-white/10">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://foxrivermarketing.net/wp-content/uploads/2026/03/FRMG-Logo-1.png" alt="Fox River Marketing Logo" className="object-contain !w-[100px] !h-[100px]" />
            </Link>
            <p className="text-[#F6FAFE]/60 text-xs leading-relaxed max-w-xs">
              Fox River Marketing is a strategic digital consultancy focused on driving measurable revenue growth for small and local businesses through data-driven marketing.
            </p>
            <div className="flex flex-col gap-3 mt-2">
              <div className="flex items-center gap-3 text-xs text-[#F6FAFE]/60">
                <MapPin className="size-4 shrink-0 text-[#FF6600]" />
                <span>26402 N Edgemond Ln, Barrington, IL 6010</span>
              </div>
              <div className="flex items-center gap-3 text-xs text-[#F6FAFE]/60">
                <Mail className="size-4 shrink-0 text-[#FF6600]" />
                <Link to="mailto:hello@foxrivermarketing.com" className="hover:text-[#FF6600] transition-colors">hynek@foxrivermarketing.com</Link>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-sans font-semibold text-[#F6FAFE] tracking-tight">Quick Links</h3>
            <MenuProvider menu_id="28" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-sans font-semibold text-[#F6FAFE] tracking-tight">Our Services</h3>
            <ul className="flex flex-col gap-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="/ServicesAndSEOPage" className="text-[#F6FAFE]/60 hover:text-[#FF6600] transition-colors text-xs">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-sans font-semibold text-[#F6FAFE] tracking-tight">Connect</h3>
            <p className="text-[#F6FAFE]/60 text-xs mb-2">
              Follow us for digital marketing insights and growth strategies.
            </p>
            <div className="flex items-center gap-4">
              {[{
              icon: Twitter,
              href: "https://twitter.com"
            }, {
              icon: Facebook,
              href: "https://facebook.com"
            }, {
              icon: Linkedin,
              href: "https://linkedin.com"
            }, {
              icon: Instagram,
              href: "https://instagram.com"
            }].map((social, i) => <Link key={i} data-index={i} to={social.href} newTab className="bg-white/5 p-2.5 rounded-none text-[#F6FAFE]/60 hover:bg-[#FF6600] hover:text-white transition-all duration-300 group" aria-label="Social Link">
                  <social.icon className="size-5" />
                </Link>)}
            </div>
          </div>

        </div>

        <Separator className="my-12 bg-white/10" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-xs text-[#F6FAFE]/60">
          <p>&copy; {currentYear} Fox River Marketing. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-[#FF6600] transition-colors">Back to Top</Link>
            <Link to="/ContactPage" className="hover:text-[#FF6600] transition-colors">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>;
}